import { ResolvedError } from '@wix/yoshi-flow-editor/error-handler';

export function isResolvedError(error: unknown): error is ResolvedError {
  return !(error instanceof Error) && typeof error === 'object' && error !== null && 'message' in error;
}
